<template>
  <div class="wrap">
    <div class="banners">
      <img src="../../assets/images/banner.png" alt="" />
    </div>
    <div class="content" v-if="(shopData == 1)">
      <div class="list">
        <div class="models">
          <span>订单号</span>
          <!-- v-model="product.connectName"  -->
          <input type="text"  :value="listData.orderId || '暂无数据'" placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <span>状态</span>
          <!--  v-model="product.connectNumber" -->
          <input type="text"  :value="String(listData.statusDes) || '暂无数据'" placeholder=" " :disabled='true' />
        </div>

        <div class="models">
          <!--  v-model="fieldValue" -->
          <span>车型</span>
          <input
            type="text"
            :value="listData.carTypeName|| '暂无数据'"
            placeholder=" "
            :disabled='true'
          />
        </div>

        <div class="models">
          <!--   v-model="product.reserveTime" -->
          <span>联系人</span>
          <input type="text" placeholder=" "  :value="listData.connectName || '暂无数据'" :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>联系方式</span>
          <input type="text" :value="listData.connectNumber|| '暂无数据'" placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>预约时间</span>
          <input type="text" :value="listData.reserveTime|| '暂无数据'" placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>出厂续航</span>
          <input type="text" :value="listData.enduranceMileage|| '暂无数据'" readonly placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>检测设备</span>
          <input type="text" :value="listData.deviceCode|| '暂无数据'" readonly placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>额定电压</span>
          <input type="text" :value="listData.kv|| '暂无数据'" readonly placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>额定容量</span>
          <input type="text" :value="listData.kva|| '暂无数据'" readonly placeholder=" " :disabled='true'/>
        </div>
      </div>
      <button @click="tosearch">返回</button>
    </div>
    <div class="content" v-else>
      <div class="list">
        <div class="models">
          <span>订单号</span>
          <!-- v-model="product.connectName"  -->
          <input type="text" :value="listData.orderId || '暂无数据'" placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <span>状态</span>
          <!--  v-model="product.connectNumber" -->
          <input type="text"  :value="String(listData.statusDes) || '暂无数据'" placeholder=" " :disabled='true' />
        </div>

        <div class="models">
          <!--  v-model="fieldValue" -->
          <span>车型</span>
          <input
            type="text"
            :value="listData.carTypeName|| '暂无数据'"
            placeholder=" "
            :disabled='true'
          />
        </div>

        <div class="models">
          <!--   v-model="product.reserveTime" -->
          <span>联系人</span>
          <input type="text" placeholder=" "  :value="listData.connectName || '暂无数据'" :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>联系方式</span>
          <input type="text" :value="listData.connectNumber|| '暂无数据'" placeholder=" " :disabled='true'/>
        </div>
        <div class="models">
          <!--      v-model="enterpriseName" -->
          <span>预约时间</span>
          <input type="text" :value="listData.reserveTime|| '暂无数据'" placeholder=" " :disabled='true'/>
        </div>
      </div>
      <button @click="tosearch">返回</button>
    </div>
  </div>
</template>

<script>
import {detailTails,userDetails } from "@/api/api.config";
export default {
  data() {
    return {
      orderId: "",
      listData:{},
      shopData:"",
    };
  },
  methods: {
    async detailTails(){
        let result = await detailTails({orderId:this.orderId})
        this.listData = result.data.data
    },
    async userDetails(){
        let result = await userDetails({orderId:this.orderId})
        this.listData = result.data.data
    },
    tosearch(){
      this.$router.back()
    }
  },
  mounted(){
    if(this.shopData ==0 ){
      this.userDetails()
    }else{
      this.detailTails();
    }
    this.shopData = localStorage.getItem('shopData')
    
  },
  created() {
    this.orderId = this.$route.query.orderId;
  },
};
</script>

<style scoped>
.banners {
  height: auto;
  max-width: 100%;
  max-height: 100%;
  vertical-align: bottom;
  bottom: 0;
  object-fit: fill;
}

.banners img {
  width: 100%;
}

.content {
  padding: 0px 20px;
  /* height: 600px; */
  overflow-y: auto;
}

input {
  text-align: right;
  background: transparent;
  width: 80%;
}

.flex-s {
  display: flex;
  justify-content: space-between;
  height: 40px;
  border-radius: 23px;
  border: 1px solid #cccccc;
  line-height: 40px;
  font-size: 14px;
  color: #999999;
  box-sizing: border-box;
}

.flex-s p {
  width: 112px;
  padding-left: 14px;
}

.colors {
  background: #2462fd;
  color: #ffffff;
  border-radius: 23px 0px 0px 23px;
}

.colors1 {
  background: #2462fd;
  color: #ffffff;
}

.colors2 {
  background: #2462fd;
  color: #ffffff;
  border-radius: 0px 23px 23px 0px;
}

.details {
  text-align: center;
  margin-top: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.details a {
  color: #2462fd;
}

.details img {
  margin-right: 4px;
}

.details a:active {
  color: #2462fd !important;
}

.models {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #f9f9f9;
  padding: 19px 0px;
  font-size: 16px;
  color: #333333;
}

input::placeholder {
  text-align: right;
  font-size: 16px;
  color: #cccccc;
}

.title-red {
  width: 100%;
  height: 48px;
  position: fixed;
  bottom: 100px;
  padding: 0px 12px;
}
.title-red p {
  font-size: 12px;
  color: red;
}
.footer {
  width: 100%;
  height: 48px;
  background: #f4f7ff;
  position: fixed;
  bottom: 50px;
  padding: 0px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.footer .left {
  display: flex;
}

.footer .span {
  margin-left: 20px;
  font-size: 14px;
  color: #333333;
}

button {
  width: 200px;
  height: 35px;
  background: #2462fdff;
  border-radius: 20px;
  color: #ffffff;
  line-height: 28px;
  text-justify: unset;
  /* margin-left: 20px; */
  margin: 30px auto;
  display: block;
}

.footer .left ::v-deep .van-checkbox__icon .van-icon {
  width: 12px !important;
  height: 12px !important;
  position: absolute;
  top: 18px;
}

.footer .left ::v-deep .van-icon-success:before {
  content: "\e728";
  position: absolute;
  top: -4px;
  left: -2px;
}

.choose_more {
  margin-top: 10px;
}

.choose_more .top {
  display: flex;
  height: 30px;
  align-items: center;
}

.ip1 {
  display: flex;
  background: #f9f9f9;
  justify-content: space-between;
  height: 47px;
  line-height: 47px;
  align-items: center;
  margin: 10px 0px;
}

.ip1 .span {
  font-size: 14px;
  color: #999999;
  margin-left: 19px;
}

.ip2 {
  display: flex;
  justify-content: space-between;
  height: 47px;
  line-height: 47px;
  align-items: center;
  background: #eff3fd;
  border-radius: 10px;
  border: 1px solid #cfddff;
  margin: 10px 0px;
  box-sizing: border-box;
}

.span2 {
  color: #2462fd;
  margin-left: 19px;
  font-size: 14px;
}

.chbox {
  border-radius: 50%;
}

.chbox {
  width: 16px;
  height: 16px;
  margin: 2px 5px 0 0;
  background: transparent;
  border: 1px solid gray;
}

.chbox[type="checkbox"] {
  -webkit-appearance: none;
  vertical-align: middle;
  margin-top: 0;
  background: #fff;
  border: #999 solid 1px;
  border-radius: 50%;
  min-height: 16px;
  min-width: 16px;
  position: relative;
  cursor: pointer;
}

.chbox[type="checkbox"]:checked {
  background: #3190e8;
  border: none;
}

.chbox[type="checkbox"]:checked::after {
  content: "";
  top: 1px;
  left: 2px;
  position: absolute;
  background: transparent;
  border: #fff solid 2px;
  border-top: none;
  border-right: none;
  height: 6px;
  width: 10px;
  -moz-transform: rotate(-45deg);
  -ms-transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.bgimgs {
  padding: 0px 20px;
}

.bgimgs .bgimg {
  display: flex;
  margin-top: 20px;
}

.bgimgs .bgimg img {
  width: 49%;
  height: 90px;
  margin: 0px 1%;
}

.imgSrc {
  width: 49%;
  height: 90px;
}

::v-deep .van-cell {
  /* position: relative; */
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  box-sizing: border-box;
  width: 100%;
  padding: 0px 0px;
  overflow: hidden;
  color: #323233;
  font-size: 14px;
  line-height: 24px;
  background-color: #fff;
}

::v-deep .van-field__control {
  display: block;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  margin: 0;
  padding: 0;
  color: #323233;
  line-height: inherit;
  background-color: transparent;
  border: 0;
  resize: none;
  text-align: right;
}

::v-deep .van-icon-arrow:before {
  /* content: '\e660'; */
  display: none;
}

::v-deep .van-icon-arrow:before {
  /* content: '\e660'; */
  display: none;
}
</style>
